'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  (function (Instagram, $) {

    Instagram.init = function () {
      $('body').on('mouseenter', '.fs-entry-container:nth-of-type(5n)', function () {
        $('.fs-slider-next-button').addClass('active');
      });
      $('body').on('mouseleave', '.fs-entry-container:nth-of-type(5n)', function () {
        $('.fs-slider-next-button').removeClass('active');
      });

      $('body').on('mouseenter', '.fs-entry-container:nth-of-type(5n+1)', function () {
        $('.fs-slider-prev-button').addClass('active');
      });
      $('body').on('mouseleave', '.fs-entry-container:nth-of-type(5n+1)', function () {
        $('.fs-slider-prev-button').removeClass('active');
      });
    };
  })(window.Instagram = window.Instagram || {}, _jquery2.default, undefined);
};